import MuiDrawer from "@mui/material/Drawer";

export default function Drawer(props) {
  return <MuiDrawer {...props} />;
}
